import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/homeData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen
          ? 'border-b border-background-200 bg-background-50/95 backdrop-blur'
          : 'border-b border-transparent bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-[72px] w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="group flex items-center gap-2.5 whitespace-nowrap">
          <span
            className={`flex h-10 w-10 items-center justify-center rounded-xl font-heading text-xl ${
              scrolled || menuOpen
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-50/90 text-primary-600'
            }`}
          >
            91
          </span>
          <span
            className={`font-heading text-2xl tracking-tight ${
              scrolled || menuOpen ? 'text-foreground-950' : 'text-white'
            }`}
          >
            免费
          </span>
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className={`inline-flex whitespace-nowrap rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
                  scrolled
                    ? 'text-foreground-700 hover:bg-secondary-100 hover:text-primary-700'
                    : 'text-white/85 hover:bg-white/15 hover:text-white'
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href="#top"
            className={`hidden whitespace-nowrap rounded-lg px-4 py-2.5 text-sm font-semibold transition-colors lg:inline-flex ${
              scrolled
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50/90 text-primary-600 hover:bg-white'
            }`}
          >
            收藏本站
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`inline-flex h-11 w-11 items-center justify-center rounded-lg transition-colors md:hidden ${
              scrolled ? 'text-foreground-900 hover:bg-secondary-100' : 'text-white hover:bg-white/15'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-lg px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-secondary-100"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}